import React from "react";
import { Link } from "react-router-dom";
import * as opOrderStatsService from "../services/openprintStats.service";
import { IoIosRefresh } from "react-icons/io";

// "YYYY-MM-DD" -> "October 26 - Monday". Parsed with an explicit local time
// so it doesn't shift a day when the browser isn't in UTC.
const formatCalendarDate = (dateStr) => {
  const date = new Date(`${dateStr}T00:00:00`);
  if (isNaN(date.getTime())) return dateStr;
  const monthDay = date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
  });
  const weekday = date.toLocaleDateString("en-US", { weekday: "long" });
  return `${monthDay} - ${weekday}`;
};

class OpMugBoxRequirements extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dates: [],
      error: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    // Combined endpoint also backing the Puzzle card — this component only
    // reads its own half of the response (see OpBoxRequirementsHandler).
    opOrderStatsService
      .getBoxRequirements()
      .then((response) => {
        this.setState({ dates: response.mug?.dates || [], error: null });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ error: "Failed to load box requirements." });
      });
  };

  refresh = (event) => {
    // Keep this click from also triggering the card's own navigation.
    event.preventDefault();
    event.stopPropagation();
    this.fetchData();
  };

  render() {
    const { dates, error } = this.state;
    return (
      <Link
        to="/openprint/orders/mug-boxes"
        className="block shadow-lg ml-0.5 mt-1 px-4 py-6 w-full bg-gray-800 hover:bg-gray-750 transition-colors relative grow"
      >
        <span className="text-sm w-max text-white dark:text-white font-semibold border-b border-gray-200">
          Upcoming Mug Box Requirements
        </span>
        <button
          onClick={this.refresh}
          className="float-right text-md text-white"
          title="Refresh"
        >
          <IoIosRefresh className="hover:text-green-700" />
        </button>

        {error && (
          <p className="text-xs text-red-300 mt-4">{error}</p>
        )}

        <div className="mt-4 space-y-4">
          {dates.map((day, index) => (
            <div key={day.date}>
              <p className="text-xs uppercase tracking-wide text-gray-400">
                {formatCalendarDate(day.date)}
              </p>
              {day.boxes.length === 0 ? (
                <p className="text-sm text-gray-500 italic mt-1">
                  No boxes needed
                </p>
              ) : (
                <ul className="mt-1 space-y-0.5">
                  {day.boxes.map((box) => (
                    <li
                      key={box.size}
                      className="text-sm text-white flex justify-between"
                    >
                      <span className="font-bold">{box.count}</span>
                      <span className="text-gray-300">{box.size}</span>
                    </li>
                  ))}
                </ul>
              )}
              {index < dates.length - 1 && <hr className="mt-3 border-gray-700" />}
            </div>
          ))}
        </div>
      </Link>
    );
  }
}

export default OpMugBoxRequirements;
